import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { CompareResults } from "../../../queries/useBuildComparison";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { PriceDisplay } from "../../../ui/PriceDisplay/PriceDisplay";
import { gridCellClass } from "./TireComparisonGrid";
import { selectPricingContext } from "./selectPricingContext";
import { useShouldRenderPricing } from "./useShouldRenderPricing";

type ProductInfoProps = {
  part: TirePartItem;
  pricing: CompareResults["partQuantity"];
  quantity: 2 | 4;
};

export const GrandTotal: FunctionComponent<ProductInfoProps> = ({
  part,
  pricing,
  quantity,
}) => {
  const { t } = useTranslation();
  const { grandTotal } = selectPricingContext(pricing, quantity);
  return (
    <div className={gridCellClass}>
      {useShouldRenderPricing(part) ? (
        <PriceDisplay>{grandTotal}</PriceDisplay>
      ) : (
        t("compare.notAvailable")
      )}
    </div>
  );
};
